import { render, staticRenderFns } from "./portal_Product-description-template.vue?vue&type=template&id=91be5c9e&scoped=true&"
import script from "./portal_Product-description-template.vue?vue&type=script&lang=js&"
export * from "./portal_Product-description-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91be5c9e",
  null
  
)

export default component.exports